import Api from "../Api"


const getPermissoesGrupos = async (page,perPage) => {

    
    let params =[];

    if(page != null){
        params.push('page='+page)
    }
   if(page != null){
        params.push('perPage='+page)
    }

    try {
        const { data } = await Api.get('/permissoes/grupos?'+params.join('&'))
        return data;
    } catch (error) {
        //console.log(error)
    }

}
const getGrupoById= async (IdPermissaoGrupo) => {

    try {
        const { data } = await Api.get('/permissoes/grupos/'+IdPermissaoGrupo)
        return data;
    } catch (error) {
        //console.log(error)
    }

}

const getAllSecoes= async (filtros) => {

    
    let params =[];

    if(filtros?.separadoPorArea != null){
        params.push('separadoPorAreas='+filtros?.separadoPorArea)
    }

    
    try {
        const { data } = await Api.get('/permissoes/secoes/?'+params.join('&'))
        return data;
    } catch (error) {
        //console.log(error)
    }

}
const getAllAreas= async () => {

    try {
        const { data } = await Api.get('/permissoes/areas/')
        return data;
    } catch (error) {
        //console.log(error)
    }

}
const verificaPermissao= async (permissoes) => {

    let formData = {
        permissoes:permissoes
    }

    try {
        const { data } = await Api.post('/permissoes/verificaPermissao/',formData)
        return data;
    } catch (error) {
        //console.log(error)
    }

}

const verificaPermissaoAreas= async () => {


    try {
        const { data } = await Api.post('/permissoes/verificaPermissaoAreas/')
        return data;
    } catch (error) {
        //console.log(error)
    }

}

const storeGruposPermissoes= async (formData) => {


    try {
        const { data } = await Api.post('/permissoes/grupos',formData)
        return data;
    } catch (error) {
        //console.log(error)
    }

}

const updateGruposPermissoes= async (idGrupo,formData) => {


    try {
        const { data } = await Api.put('/permissoes/grupos/'+idGrupo,formData)
        return data;
    } catch (error) {
        //console.log(error)
    }

}
export const PermissoesService = {
    getPermissoesGrupos,
    getGrupoById,
    getAllSecoes,
    getAllAreas,
    verificaPermissao,
    updateGruposPermissoes,
    storeGruposPermissoes,
    verificaPermissaoAreas
}